<!-- List.vue -->
<template>
	<div>
		<div class="common-header-wrap">
			<mt-header title="自提门店" class="common-header">
				<mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
			</mt-header>
		</div>
		<div class="common-popup-content" id="my_map"></div>
	</div>
</template>

<script>
import { getChainList } from '../../../api/homegoodsdetail'
import { loadScript } from '../../../util/common'
import { convertPoint } from '../../../util/bmap'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      myMap: false,
      goods_id: this.$route.query.goods_id
    }
  },

  props: ['list'],
  computed: {
    ...mapState({
      config: state => state.config.config
    }),
  },
  created () {},
  mounted () {
	  let _this = this
	  if(_this.config.mapak_type == '1'){
		//高德地图API功能
		loadScript('Amap', '//webapi.amap.com/maps?v=2.0&key=' + _this.config.gaode_ak, function () {
			let map = new AMap.Map('my_map', {
			  zoom: 10
			});
			getChainList({ goods_id: _this.goods_id }).then(res => {
			    let chain_list = res.result.chain_list
			    for (var i in chain_list) {
					let marker = new AMap.Marker({
					    position: new AMap.LngLat(chain_list[i].chain_longitude, chain_list[i].chain_latitude),
					    icon: '//api.map.baidu.com/images/marker_red_sprite.png',
						zoom: 15
					});
					map.add(marker);
			    }
			  })
			})
	  }else{
		  loadScript('bmap', '//api.map.baidu.com/api?ak=' + env.BMAP_AK_BRO + '&type=lite&v=1.0', function () {
		    // 百度地图API功能
		    let map = new BMap.Map('my_map') // 创建Map实例
		    navigator.geolocation.getCurrentPosition(function (position) {
		  // 	  console.log(position)
		      convertPoint(position.coords.longitude, position.coords.latitude).then(result => {
		        if (result.status == 0) {
		          var point = new BMap.Point(result.result[0].x, result.result[0].y)
		          map.centerAndZoom(point, 16)
		        } else {
		  
		        }
		      }).catch(error => {
		  
		      })
		    }, function (error) {}, { enableHighAcuracy: true })
		  
		    _this.myMap = map
		    getChainList({ goods_id: _this.goods_id }).then(res => {
		      let chain_list = res.result.chain_list
		      for (var i in chain_list) {
		        _this.mapAddMarker(chain_list[i])
		      }
		    })
		  })
	  }
  },
  methods: {

    mapAddMarker (info) {
      var point = new BMap.Point(info.chain_longitude, info.chain_latitude)
      var marker = new BMap.Marker(point) // 创建标注
      this.myMap.addOverlay(marker) // 将标注添加到地图中
    }
  }
}
</script>

<style lang="scss">
	.common-header-wrap .common-header{box-shadow: unset}

</style>
